module.exports = __webpack_public_path__ + "static/media/mode-2003.f85b087d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-2003.svg
// module id = 1027
// module chunks = 2